import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updateFeedFilterPriorityCell } from '../../actions/feed-filters/grid';
import { changeFeedFiltersAutobudgetPriority } from '../../actions/feed-filters/priority-form';
import { cancelCellEdit } from '../../actions/grid-screen';
import {
    FeedFilterPriorityCellEditor,
    FeedFilterPriorityCellEditorProps
} from '../../components/FeedFilterPriorityCellEditor/FeedFilterPriorityCellEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export type StateProps = Pick<FeedFilterPriorityCellEditorProps, 'isSaving' | 'error'>;

export interface DispatchProps {
    onSave: () => void;
    onCancel: () => void;
    onInitialValuesSet: (autobudgetPriority: GdShowConditionAutobudgetPriority) => void;
}

export interface OwnProps {
    feedFilterId: string;
    cellName: string;
    autobudgetPriority?: GdShowConditionAutobudgetPriority;
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData } = state.grid;
    const { feedFilterId, cellName } = ownProps;
    const { view } = selectGridSourceParams(state);

    return getEditCellData(editCellsData, feedFilterId, cellName, view);
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { cellName, feedFilterId } = ownProps;

    return {
        onSave() {
            dispatch(updateFeedFilterPriorityCell(feedFilterId, cellName));
        },
        onCancel() {
            dispatch(cancelCellEdit(feedFilterId, cellName));
        },
        onInitialValuesSet(autobudgetPriority: GdShowConditionAutobudgetPriority) {
            dispatch(changeFeedFiltersAutobudgetPriority(autobudgetPriority));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): FeedFilterPriorityCellEditorProps => {
    const { autobudgetPriority } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        autobudgetPriority
    };
};

export const FeedFilterPriorityCellEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    FeedFilterPriorityCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(FeedFilterPriorityCellEditor);
